import { visitServiceApi } from "../../app/visitServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetVisitRangeParamsType,
  BulkAssignVisitResponseType,
  BulkAssignVisitRow,
  MyVisitListExportParams,
  MyVisitQueryParams,
  MyVisitResponseType,
  TeamVisitQueryParams,
  TeamVisitResponseType,
  VisitDetailsResponseType,
  VisitListExportQueryParams,
  VisitListExportType,
} from "../../types/visit";

export const visitApi = visitServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getMyVisitList: builder.query<
      MyVisitResponseType,
      GetQueryArgsType<MyVisitQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMyVisitList,
        ...queryArgs,
      }),
    }),
    getMyVisitListMinimum: builder.query<
      MyVisitResponseType,
      GetQueryArgsType<MyVisitQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMyVisitListMinimum,
        ...queryArgs,
      }),
    }),
    getTeamVisitList: builder.query<
      TeamVisitResponseType,
      GetQueryArgsType<TeamVisitQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTeamVisitList,
        ...queryArgs,
      }),
    }),
    bulkAssignVisit: builder.mutation<
      BulkAssignVisitResponseType,
      { rows: BulkAssignVisitRow[] }
    >({
      query: (body) => ({
        url: API_URL.bulkAssignVisit,
        method: "POST",
        body,
      }),
    }),
    getVisitDetails: builder.query<VisitDetailsResponseType, string>({
      query: (id) => ({
        url: `${API_URL.getVisitDetails}/${id}`,
      }),
    }),
    getVisitListExport: builder.query<
      VisitListExportType,
      GetQueryArgsType<VisitListExportQueryParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getVisitListExport,
        ...queryArgs,
      }),
    }),
    getMyVisitListExport: builder.query<
      VisitListExportType,
      GetQueryArgsType<MyVisitListExportParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getVisitListExport,
        params: {
          ...queryArgs,
        },
      }),
    }),
    getVisitDetailsExport: builder.query<
      void,
      GetQueryArgsType<GetVisitRangeParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getVisitDetailsExport,
        responseHandler: async (response: any) => {
          const blob = await response.blob();
          return window.URL.createObjectURL(blob);
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useGetMyVisitListQuery,
  useGetMyVisitListMinimumQuery,
  useGetTeamVisitListQuery,
  useBulkAssignVisitMutation,
  useGetVisitDetailsQuery,
  useGetVisitListExportQuery,
  useLazyGetVisitListExportQuery,
  useGetMyVisitListExportQuery,
  useGetVisitDetailsExportQuery,
  useLazyGetVisitDetailsExportQuery,
} = visitApi;
